import { createAction } from '@reduxjs/toolkit';

export const changeLoader = createAction('loader/changeLoader');
